import { render } from "./EditRegionModal.vue?vue&type=template&id=7eb71382&scoped=true"
import script from "./EditRegionModal.vue?vue&type=script&lang=js"
export * from "./EditRegionModal.vue?vue&type=script&lang=js"

import "./EditRegionModal.vue?vue&type=style&index=0&id=7eb71382&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eb71382"]])

export default __exports__